export default "__VITE_ASSET__CMuOFzYr__"